export const ROUTES = {
  notFound: "/not-found",
  support: {
    index: "/support",
    confirmation: "/support/confirmation",
    embed: {
      index: "/embed/support",
      confirmation: "/embed/support/confirmation",
    },
  },
  booking: {
    embed: {
      index: "/embed/book",
      success: "/embed/book/success",
    },
  },
} as const;
